import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const COLOR_MAP = {
  green: {
    section: "text-emerald-600 dark:text-emerald-400",
    bg: "bg-emerald-50/50 dark:bg-emerald-950/20",
    border: "border-emerald-100 dark:border-emerald-900/30",
    next: "text-emerald-600 hover:text-emerald-700 dark:text-emerald-400",
  },
  blue: {
    section: "text-blue-600 dark:text-blue-400",
    bg: "bg-blue-50/50 dark:bg-blue-950/20",
    border: "border-blue-100 dark:border-blue-900/30",
    next: "text-blue-600 hover:text-blue-700 dark:text-blue-400",
  },
  amber: {
    section: "text-amber-600 dark:text-amber-400",
    bg: "bg-amber-50/50 dark:bg-amber-950/20",
    border: "border-amber-100 dark:border-amber-900/30",
    next: "text-amber-600 hover:text-amber-700 dark:text-amber-400",
  },
  neutral: {
    section: "text-slate-500 dark:text-slate-400",
    bg: "bg-slate-50/50 dark:bg-slate-900/20",
    border: "border-slate-100 dark:border-slate-800/30",
    next: "text-[#1a4d3e] hover:text-[#1a4d3e]/80",
  },
};

export function ContextHeader({ section, title, purpose, nextStep, nextHref, onNextClick, color = "neutral" }) {
  const c = COLOR_MAP[color] || COLOR_MAP.neutral;

  const nextClasses = `flex items-center gap-1 text-xs font-medium whitespace-nowrap mt-1 ${c.next} transition-colors`;

  return (
    <div className={`px-6 py-4 ${c.bg} border-b ${c.border}`} data-testid="context-header">
      <div className="max-w-4xl mx-auto flex items-start justify-between gap-4">
        <div className="min-w-0">
          <p className={`text-[10px] font-bold uppercase tracking-widest ${c.section} mb-0.5`} data-testid="context-section">
            {section}
          </p>
          <h2 className="text-base font-semibold text-foreground leading-tight" data-testid="context-title">
            {title}
          </h2>
          <p className="text-sm text-muted-foreground mt-0.5 leading-snug" data-testid="context-purpose">
            {purpose}
          </p>
        </div>
        {nextStep && onNextClick && (
          <button
            onClick={onNextClick}
            className={nextClasses}
            data-testid="context-next-step"
          >
            {nextStep}
            <ArrowRight className="w-3 h-3" />
          </button>
        )}
        {nextStep && nextHref && !onNextClick && (
          <Link
            to={nextHref}
            className={nextClasses}
            data-testid="context-next-step"
          >
            {nextStep}
            <ArrowRight className="w-3 h-3" />
          </Link>
        )}
      </div>
    </div>
  );
}
